import { useDeletePartMutation } from "@common/api/parts"
import { handleError } from "@common/utils"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { DeleteDialog } from "@/components/layout/list-table-menu"
import useCustomToast from "@/hooks/use-custom-toast"
import { requirePermission } from "@/lib/require-permission"

export const Route = createFileRoute("/_layout/inventory/delete/$partId")({
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(queryClient, "part:delete", "/"),
  component: DeletePartDialog,
})

function DeletePartDialog(): React.ReactElement {
  const { partId } = Route.useParams()
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const remove = useDeletePartMutation()

  const close = () => navigate({ to: "/inventory", search: true })

  return (
    <DeleteDialog
      noun="part"
      pending={remove.isPending}
      onCancel={close}
      onConfirm={() =>
        remove.mutate(
          { part_id: partId },
          {
            onSuccess: () => {
              showToast("Deleted", "Part deleted.", "success")
              close()
            },
            onError: (error) => handleError(error, showToast),
          },
        )
      }
    />
  )
}
